import { RemoteSearchProps, remoteApi } from '@linecorp/dosi/remote';
import { RefCallback, useCallback, useEffect, useRef } from 'react';
import { StoreApi } from 'zustand';

export const useRemoteComponent = <P = unknown>(component: string, props?: P) => {
  const api = useRef<StoreApi<P> | null>(null);
  const ref: RefCallback<HTMLElement> = useCallback(
    async (element) => {
      if (api.current) return;
      const { render } = await remoteApi.fetchComponent<P>(component);
      api.current = render(element, props);
    },
    [component, props]
  );
  useEffect(() => {
    if (props) {
      api.current?.setState(props);
    }
  }, [props]);
  return ref;
};

export const useRemoteSearchComponent = (props: RemoteSearchProps) =>
  useRemoteComponent('search', props);

export * from '@linecorp/dosi/remote';
